export default __webpack_public_path__ + "static/media/Zone-Master-Plan-Type-G.65c337ab.png";